$(document).ready(function(){
    // NOTE: trigeringFromKaching is now per-productBox (stored in data)
    // Click gender buttons inside productBox
    $(document).on('click', '.gempages_pp_gender-btn', function(){
        var $box = $(this).closest('.productBox');
        $box.find('.gempages_pp_gender-btn').removeClass('active');
        $(this).addClass('active');
        var currentData = $(this).attr('data');

        $box.find('.pp_size-btn-inner').addClass('hided');
        $box.find('.pp_size-btn-inner[data-type="'+currentData+'"]').removeClass('hided');
    });

    // Swatch click inside productBox
    $(document).on('click', '.gempage_swatch-box', function(){
        var $box = $(this).closest('.productBox');
        $box.find('.gempage_swatch-box').removeClass('activeOption');
        $(this).addClass('activeOption');

        // call scoped getVariant
        getVariant($box);

        var currentVal = $(this).attr('data-full-value');
        var trig = $box.data('trigeringFromKaching') || false;
        if (trig == false){
            // only update selects inside same productBox
            $box.find('.kaching-bundles__bar-variant-select[data-name="Color"]').val(currentVal);
            $box.find('.kaching-bundles__bar-variant-select[data-name="Color"]').attr('data-value', currentVal);
        }
        // console.log(currentVal, 'CURRENT VALUE');
    });

    // Size button click inside productBox
    $(document).on('click', '.gempages_pp_size-btn', function(){
        var $box = $(this).closest('.productBox');
        $box.find('.gempages_pp_size-btn').removeClass('active');
        $(this).addClass('active');

        // call scoped getVariant
        getVariant($box);

        var currentVal = $(this).attr('data-full-value');
        var trig = $box.data('trigeringFromKaching') || false;
        if (trig == false){
            $box.find('.kaching-bundles__bar-variant-select[data-name="Size"]').val(currentVal);
            $box.find('.kaching-bundles__bar-variant-select[data-name="Size"]').attr('data-value', currentVal);
        }
        
    });

    // ---- scoped getVariant: accepts optional $box jQuery element ----
    // If no $box passed, fallback to first .productBox to remain backwards-compatible
    function getVariant($box){
        if (!$box || !$box.length) {
            $box = $('.productBox').first();
            if (!$box.length) return; // nothing to do
        }

        // build full title (same as your original) scoped to the box
        var colorSel = $box.find('.gempage_swatch-box.activeOption').attr('data') || '';
        var sizeSel  = $box.find('.gempages_pp_size-btn.active').attr('data') || '';
        var fullTitle = colorSel + '-' + sizeSel;

        var newId = '';
        var available = false;

        // iterate variant selections inside the box
        $box.find('.gempages_pp-variant-selection').each(function(){
            if (fullTitle == $(this).attr('data-title')){
                newId = $(this).attr('data-id') || '';
                if ($(this).attr('data-available') == 'true') available = true;
            }
        });

        // update ATC button inside this box
        $box.find('.gempages_pp-atc-btn').attr('data-id', newId);
        $box.find('.atc_btn_text').html(available ? 'Add to cart' : 'Sold out');

        // if no variant found, stop
        if (!newId) return;

        // find template and its HTML (templates are global, but replacement is scoped)
        var $tpl = $('template.gempages_gallery-array[data-id="' + newId + '"]');
        if (!$tpl.length) return;

        var html = $tpl.html();
        var $tmp = $(html);

        // get new main & carousel from template content
        var $newMain = $tmp.filter('.gempages_gallery-main');
        var $newCarousel = $tmp.filter('.gempages_gallery-carousel-wrapper');

        // replace only the gallery inside this productBox
        var $existingMain = $box.find('.gempages_gallery-main').first();
        var $existingCarousel = $box.find('.gempages_gallery-carousel-wrapper').first();

        if ($newMain.length && $existingMain.length) {
            $existingMain.replaceWith($newMain);
        } else if ($newMain.length && !$existingMain.length) {
            // insert if missing
            $box.find('.some-insertion-point').first().before($newMain); // fallback - adjust if needed
        }

        if ($newCarousel.length && $existingCarousel.length) {
            $existingCarousel.replaceWith($newCarousel);
        } else if ($newCarousel.length && !$existingCarousel.length) {
            // append after main if missing
            $box.find('.gempages_gallery-main').first().after($newCarousel);
        }

        // ensure first thumbnail is active and main image set within this box
        var $firstThumb = $box.find('.gempages_gallery-carousel-cell').first();
        if ($firstThumb.length) {
            $box.find('.gempages_gallery-carousel-cell').removeClass('active');
            $firstThumb.addClass('active');
            var src = $firstThumb.find('img').attr('src');
            if (src) $box.find('.gempages_gallery-main-img img').attr('src', src);
        }
    }

    // Kaching select change: scope to productBox of select
    $(document).on('change', '.kaching-bundles__bar-variant-select', function() {
        var $select = $(this);
        var $box = $select.closest('.productBox');
        if (!$box.length) $box = $('.productBox').first();

        // set per-box flag so the click handlers don't echo back to the selects
        $box.data('trigeringFromKaching', true);
        setTimeout(function(){
            $box.removeData('trigeringFromKaching');
        },500);

        var currentVal = $select.val();
        // trigger swatch & size inside same box
        $box.find('.gempage_swatch-box[data-full-value="'+currentVal+'"]').trigger('click');
        $box.find('.gempages_pp_size-btn[data-full-value="'+currentVal+'"]').trigger('click');
    });
});